import { render } from "./generateWx.vue?vue&type=template&id=1d09c5bd&scoped=true"
import script from "./generateWx.vue?vue&type=script&lang=js"
export * from "./generateWx.vue?vue&type=script&lang=js"

import "./generateWx.vue?vue&type=style&index=0&id=1d09c5bd&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d09c5bd"],['__file',"src/views/enterPriseConfig/components/generateWx.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1d09c5bd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1d09c5bd', __exports__)) {
    console.log('reload')
    api.reload('1d09c5bd', __exports__)
  }
  
  module.hot.accept("./generateWx.vue?vue&type=template&id=1d09c5bd&scoped=true", () => {
    console.log('re-render')
    api.rerender('1d09c5bd', render)
  })

}


export default __exports__